<template>
  <div>
    <b-nav pills vertical>
      <b-nav-item>
        <router-link to="/join-us"><span>&#187;</span>加入我们</router-link>
      </b-nav-item>
      <b-nav-item active>
        <router-link to="/contact-us"><span>&#187;</span>联系我们</router-link>
      </b-nav-item>
    </b-nav>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
</style>
